import axios from 'axios'

const map = {
  // 统计 pv  uv
  postStateNum: {
    url: `/cgi-op/api/v1/analyze`,
    method: 'POST',
  },
}

axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.resolve(error)
})
function OkStatus (response) {
  if (response && (response.status === 200)) {
    return response
  }
  return response
}
function ErrorStatus (res) {
  console.log('err', res)
  const regs = /^2[0-9]{2}$/
  if (!regs.test(res.status)) {
    if (res.status === 401) {
      console.log('401')
    }
    if (res.status === 302) {
      console.log('302', res)
    }
    const error = new Error(res.statusText)
    throw error
  }
  return res
}
export default function axiosAPI(type, body, appendPath = '') {
  let url = map[type].url + appendPath
  const config = {
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    credentials: 'include',
    mode: 'cors',
    method: map[type].method,
  }

  if (map[type].method === 'GET') {
    if (body) {
      url += `${body}`
    } else {
      url = url
    }
  } else {
    config.data = body
  }
  return axios(url, config)
    .then(response => {
      return OkStatus(response)
    })
    .catch(res => {
      return ErrorStatus(res.response)
    })
}




// WEBPACK FOOTER //
// ./src/utils/request.js